var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { navigatorCredentialsApi } from "apis/navigatorCredentials";
import { useEffect, useRef, useState } from "react";
import { FormattedMessage } from "react-intl";
import passkeyDarkImage from "../../../img/multiple-passkey-dark-mode.svg";
import passkeyImage from "../../../img/multiple-passkey.svg";
import passkeyIcon from "../../../img/passkey.svg";
import { EduIDButton } from "./EduIDButton";
import { useTheme } from "./ThemeContext";
export function PassKey({ setup, onSuccess, onComplete, discoverable }) {
    // The PassKey button is 'active' after first being pressed. In that mode, it shows
    // a small animation and invokes the navigator.credentials.get() thunk that will result
    // in 'fulfilled' after the user uses the security key to authenticate. The 'active' mode
    // can also be cancelled or restarted with buttons in the UI.
    const [active, setActive] = useState(false);
    const [performAuthentication] = navigatorCredentialsApi.useLazyPerformAuthenticationQuery();
    function handleSecurityKey() {
        return __awaiter(this, void 0, void 0, function* () {
            setActive(true);
            try {
                const webauth_options = yield setup();
                if (webauth_options) {
                    const response = yield performAuthentication({ webauth_options });
                    if (response.isSuccess) {
                        // Wait for credential submission to finish before calling onComplete,
                        // so that restartConditionalAuth doesn't fire a new challenge fetch
                        // while the backend is still processing this credential.
                        yield onSuccess(response.data);
                    }
                }
            }
            catch (_a) {
                // User cancelled WebAuthn dialog or browser timed out — no action needed
            }
            finally {
                setActive(false);
                onComplete === null || onComplete === void 0 ? void 0 : onComplete();
            }
        });
    }
    return _jsx(SecurityKeyInactive, { disabled: active, handleSecurityKey: handleSecurityKey, discoverable: discoverable });
}
function SecurityKeyInactive({ disabled, handleSecurityKey }) {
    const ref = useRef(null);
    const { theme } = useTheme();
    useEffect(() => {
        var _a;
        if (ref.current)
            (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, []);
    return (_jsxs("div", { className: "status-box", children: [_jsx("div", { className: "text-wrapper", children: _jsxs("div", { className: "flex-between", children: [_jsxs("div", { children: [_jsx("h2", { children: _jsx(FormattedMessage, { id: "passkey.heading", defaultMessage: "Faster and safer way to authenticate", description: "passkey heading" }) }), _jsx("p", { className: "text-medium", children: _jsx(FormattedMessage, { id: "passkey.have", defaultMessage: "If you have registered a passkey for eduid.se you can log in securely using your fingerprint, face recognition, PIN code or other screen-lock methods." }) }), _jsx("p", { className: "help-text", children: _jsx(FormattedMessage, { id: "passkey.info", defaultMessage: '\n                Read more about logging in using passkeys in the "Using eduID" section in {howPasskeyWork}. ', description: "security zone redirect info", values: {
                                            howPasskeyWork: (_jsx("a", { href: "/help#loginPasskeyHeading", target: "_blank", rel: "noreferrer", children: _jsx(FormattedMessage, { id: "common.eduidHelp", description: "passkey help text link", defaultMessage: "eduID Help" }) })),
                                        } }) })] }), _jsx("img", { src: theme === "dark" ? passkeyDarkImage : passkeyImage, alt: "", className: "passkey-image" })] }) }), _jsx("div", { className: "buttons", children: _jsxs(EduIDButton, { ref: ref, buttonstyle: "primary icon", type: "button", onClick: handleSecurityKey, id: "pass-key", disabled: disabled, children: [_jsx("img", { className: "passkey-icon", height: "20", alt: "passkey icon", src: passkeyIcon }), _jsx(FormattedMessage, { id: "passkey.button", description: "login passkey primary option button", defaultMessage: "log in with passkey" })] }) })] }));
}
